export default __webpack_public_path__ + "static/media/B_wdt_c_cap_4.91a116bd.mp3";